import { Link, Outlet } from 'react-router';
import { useCurrentUser } from '../hooks/index.js';
import { hasRole, type Me } from '../lib/auth.js';

// The SPA side of spec §4's page rules, for usability only: the server refuses the API calls
// (and the documents) on its own. /admin/onboarding* is HR's and administrators'; the rest of
// /admin is administrators'. The current portal had no client-side guard at all.

function Guard({ allowed }: { allowed: (me: Me | undefined) => boolean }) {
  const me = useCurrentUser();
  return allowed(me) ? <Outlet /> : <Forbidden />;
}

export function AdminOnly() {
  return <Guard allowed={(me) => hasRole(me, 'admin')} />;
}

export function HrOrAdmin() {
  return <Guard allowed={(me) => hasRole(me, 'admin') || hasRole(me, 'hr')} />;
}

export function Forbidden() {
  return (
    <div style={{ padding: '2rem 0' }}>
      <h1 style={{ marginBottom: '0.75rem' }}>You do not have access to this page</h1>
      <p style={{ color: 'var(--color-text-muted)' }}>
        This part of the portal is not open to your role. If you believe you need it, contact the helpdesk.
      </p>
      <p>
        <Link to="/" style={{ color: 'var(--color-accent)' }}>Back to My Compliance Portal</Link>
      </p>
    </div>
  );
}
